const viewMoreBtn = document.querySelector('a[href="#see-all-projects"]');

/* This function adjusts projects counter below secondary list,
*  it also handles number of projects being show depending on viewport.
* */
const adjustProjectsCount = () => {
    const breakpoint = 991;
    const maxNumberItems = 7;
    const maxNumberItemsPrimary = 3;
    const projects = document.querySelectorAll('.wp-block-post.type-prosjekt');
    const counter = document.querySelector('.projects-counter-secondary');
    const listContainer = document.querySelector('.splitkon-projects-secondary-list');

    if (window.innerWidth > breakpoint && !listContainer?.classList.contains('expanded')) {
        projects.item(maxNumberItems - 1)?.classList.add('hidden');
    } else {
        projects.item(maxNumberItems - 1)?.classList.remove('hidden');
    }

    // Remove button if projects' count is less than max hence there is no need to load more.
    if (projects.length < maxNumberItems) {
        viewMoreBtn?.remove();
    }

    // Remove secondary list  if projects' count is less or equal than max on primary list.
    if (projects.length <= maxNumberItemsPrimary) {
        listContainer?.remove();
    }

    const visibleProjects = document.querySelectorAll('.wp-block-post.type-prosjekt:not(.hidden)');
    if (counter) {
        counter.innerHTML = counter?.innerHTML.replace(/\b\d+\b/, visibleProjects.length);
    }
}

const handleViewMoreButton = (e) => {
    e.preventDefault();

    const listContainer = document.querySelector('.splitkon-projects-secondary-list');
    const queryEl = listContainer.querySelector('.wp-block-query');

    if (!queryEl) return;
    const block = JSON.parse(queryEl.dataset.attrs);

    const params = {
        action: 'get_all_projects',
        attrs: JSON.stringify(block)
    }

    const queryParams = new URLSearchParams();

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            queryParams.append(key, params[key]);
        }
    }

    viewMoreBtn.classList.add('loading');

    let request = new XMLHttpRequest();
    request.onreadystatechange = () => {
        if (request.readyState === 4) {
            if (request.status === 200) {
                queryEl.innerHTML = request.response;
                listContainer?.classList.add('expanded');
                adjustProjectsCount(true);
                viewMoreBtn?.remove();
            } else {
                viewMoreBtn?.classList.remove('loading');
            }
        }
    };

    request.open("GET", `${splitkon.ajax_url}?${queryParams.toString()}`, true);
    request.send();
}

if (viewMoreBtn) {
    document.addEventListener("DOMContentLoaded", adjustProjectsCount);
    window.addEventListener("resize", adjustProjectsCount);
    viewMoreBtn.addEventListener('click', handleViewMoreButton);
}
